<template>
    <div>
	    <main role="main" style = "padding-top:0px">
		 <!-- <div class="form-group row" style="background-color: rgb(162, 197, 75); width: 100%; margin: 0px; height: 51px; align-items: center;">
			 <a class="col-md-11 text-left" href="#/campaignList"><img alt="Global Overview" src="../../assets/images/logo.png" style="height:35px;"/></a>
		 </div> -->
		 <div class="spinner-border" v-if = "isLoading" style="margin-left:50%;margin-top:50%"></div>
	      <div v-else>
			  <div v-if = "currentPage == 'releaseDetail/detail'">
				   <!-- <div class="form-row bread-crumb-small" style = "margin:0px" >
					  <a href="javascript:void(0)" @click="getBackList()" style="line-height:1;margin:0px" class="form-group">Release Notes > </a>
					  <span style="line-height:1;margin:0px;padding-left:10px"> {{notesData.title}}
						<span class="detail-data">
							<p v-if = "notesData.type" style = "text-transform:capitalize" class="label label-info">{{showResource(notesData.type)}}
							</p>
						</span>
					  </span>
				  </div> -->
				  <BreadCrumbHeader
					@backCalled="getBackList"
					:selectedName="notesData.title"
					tabCalled='Release Notes'
					selectedModule='Resources & Updates'
					:showLabel='notesData.type'
					:labelName='showResource(notesData.type)'
					/>
			  </div>
			  <div v-else>
				  <!-- <h1>{{notesData.title}}
				  </h1>
				  <div class="detail-data">
					  <p v-if = "notesData.type" style = "text-transform:capitalize" class="label label-info">{{showResource(notesData.type)}}
					  </p>
				   </div> -->
				   <BreadCrumbHeader
					:selectedName="notesData.title"
					selectedModule='Resources & Updates'
					:showLabel='notesData.type'
					:labelName='showResource(notesData.type)'
					/>
			  </div>

			  <div class="table_wrap no_footer pt-2">
				  <div v-html = "notesData.description"></div>
			  </div>
	      </div>
	    </main>
    </div>
</template>

<script>

import ReleaseNotesHeader from "./ReleaseNotesHeader.vue"
import ReleaseNotesListGrid from "./ReleaseNotesListGrid.vue"
import BreadCrumbHeader from "@/components/BreadCrumbHeader.vue";
	
export default {
	name: "Detail",
	components:{BreadCrumbHeader},
	data(){
		return{
			notesData:{},
			isLoading:false
		}
	},
	computed: {
      currentPage() {
        return this.$route.name
      },
  },
	mounted(){
		let id = this.$route.params.id;
		this.isLoading = true;
		let vm = this;
		this.$store.dispatch("release/getNoteById", {id:id}).then((res) => {
			vm.isLoading = false
			vm.notesData = res
		})
	},
	methods:{
		getBackList(){
			 this.$router.push({path: '/releaseNotes'})
		},
		showResource(data){
			if(data){
				return data
			}
			else{
				return ''
			}
		}
	}
}
</script>

<style lang="scss">
.detail-data {
	margin-left:20px;
	.label {
		display: inline;
		padding: 0.2em 0.6em 0.3em;
		font-size: 75%;
		font-weight: 700;
		line-height: 1;
		color: #fff;
		text-align: center;
		white-space: nowrap;
		vertical-align: baseline;
		border-radius: 0.25em;
	}
	.label-info {
		background-color: #5bc0de;
	}
}

</style>
